import React from "react";
import ReactDOM from "react-dom";
import { Form, Formik, Field } from "formik";
import { ApiService } from "../../../../../services/ApiService";

export default function CreateLeaveModal({ closeModal, alert, getLeave }) {
  return (
    <React.Fragment>
      <div className="">
        <h4 className="modal-title w-100" style={{ color: "#000" }}>
          Create Leave
        </h4>
        <hr />
      </div>
      <Formik
        initialValues={{ type: "", number_of_days: "", year: "" }}
        onSubmit={(values) => {
          ApiService.post("leaves/create-leave", values).then((res) => {
            if (res.data.type === false) {
              alert.error(res.data.msg);
            } else if (res.data.type === true) {
              alert.success(res.data.msg);
            }
            getLeave();
            closeModal();
          });
        }}
      >
        {({ handleSubmit, values, isSubmitting }) => (
          <Form>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label>Leave type </label>
                  <span className="text-danger"> * </span>
                  <Field
                    type="text"
                    className="form-control"
                    name="type"
                    required
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label>No Of Days </label>
                  <span className="text-danger"> * </span>
                  <Field
                    type="number"
                    className="form-control"
                    name="number_of_days"
                    required
                  />
                </div>
              </div>
            </div>
            {/* 
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label>Active Year </label>
                  <Field
                    type="text"
                    className="form-control"
                    name="year"
                    disabled
                    required
                  />
                </div>
              </div>
            </div> */}
            <div className="form-group row">
              <div className="col">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
              <div className="col-md-10">
                <button
                  type="submit"
                  className="btn btn-block nt-button-color-default btn-sm"
                >
                  Save{" "}
                  {isSubmitting ? (
                    <span
                      id="login_spinner"
                      className="fa fa-spin fa-spinner"
                    ></span>
                  ) : null}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/container/dashboard/systemconfiguration/leave/modal/create_leave.js